var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 19V10.2C5 7.20021 5 5.70032 5.76393 4.64886C6.01065 4.30928 6.30928 4.01065 6.64886 3.76393C7.70032 3 9.20021 3 12.2 3H17.2C17.9499 3 18.3249 3 18.5878 3.19098C18.6727 3.25266 18.7473 3.32732 18.809 3.41221C19 3.67508 19 4.05005 19 4.8V19M9 7H15M9 10H13M6.5 21H17.5C17.9659 21 18.1989 21 18.3827 20.9239C18.6277 20.8224 18.8224 20.6277 18.9239 20.3827C19 20.1989 19 19.9659 19 19.5V19.5C19 19.0341 19 18.8011 18.9239 18.6173C18.8224 18.3723 18.6277 18.1776 18.3827 18.0761C18.1989 18 17.9659 18 17.5 18H6.5C5.67157 18 5 18.6716 5 19.5V19.5C5 20.3284 5.67157 21 6.5 21Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.9ac79d2cad646fbc5fc0e7a5dd72bf6b.svg";
export { ForwardRef as ReactComponent };